<script lang="ts">
	import { Snapshot } from "luxedo-data"
	import SnapshotModiferSelectSnapshot from "./SnapshotModifier_Select.svelte"
	import { SnapshotModifierController } from "./SnapshotModifierController.svelte"
	import { type Component, setContext } from "svelte"
	import { Responsive } from "responsive"
	import SnapshotModifierModify from "./SnapshotModifier_Modify.svelte"

	interface Props {
		snapshots: Array<Snapshot>
		cancel: () => void
		onComplete: (snapshot: Snapshot) => void
	}

	let { snapshots, cancel, onComplete }: Props = $props()

	let isMobile = $derived(Responsive.isMobile)

	let snapshotModifierController = new SnapshotModifierController(snapshots, onComplete, cancel)
	setContext("controller", snapshotModifierController)

	let view = $derived(snapshotModifierController.view)

	let compMap: { [key in typeof view]: Component<any> } = {
		select: SnapshotModiferSelectSnapshot,
		mask: SnapshotModifierModify,
	}
	let Comp = $derived(compMap[view])
</script>

<div id="snapshot-modifier" class:isMobile>
	<Comp />
</div>

<style>
	#snapshot-modifier {
		height: 100%;
		width: 100%;

		overflow: hidden;
		display: flex;
		flex-direction: column;

		--sidebar-width: 20rem;
		--mask-preview-height: 8rem;
	}

	#snapshot-modifier.isMobile {
		height: 100%;
		width: 100%;

		--sidebar-width: 100%;

		flex-direction: column;
	}

	#snapshot-modifier :global(.heading h3) {
		font-size: var(--h1);
		margin: 0;
	}

	#snapshot-modifier.isMobile :global(.heading h3) {
		text-align: center;
	}
</style>
